<template>
  <div>
    <div class="ui form clearing segment" id="new-default-package-step">
      <div class="required field">
        <label for="name">Name</label>
        <div class="ui input">
          <input type="text"
                 v-model="package.name"
                 :placeholder="'Name'"
                 name="name">
        </div>
      </div>

      <div class="field">
        <label>Description</label>
        <textarea rows="3"
                  :placeholder="'Description'"
                  v-model="package.description"
                  name="description"></textarea>
      </div>

      <div class="required field">
        <label for="unitPrice">Unit Price</label>
        <div class="ui input">
          <input type="number"
                 v-model="package.unit_price"
                 :placeholder="'Unit Price'"
                 name="unitPrice">
        </div>
      </div>

      <div class="required field">
        <label for="quantity">Quantity</label>
        <div class="ui input">
          <input type="number"
                 v-model="package.quantity"
                 :placeholder="'Quantity'"
                 name="quantity">
        </div>
      </div>

      <div class="two required fields" v-if="forItemCategory">
        <div class="field">
          <label for="reservation_type">Choose unit measurement</label>
          <select
            class="ui fluid search dropdown"
            id="unit-measurement-search"
            v-model="package.unit_measurement_id"
            name="unitMeasurement"
          >
            <option value="">Choose unit measurement</option>
            <option :value="unitMeasurement.id" v-for="unitMeasurement in unitMeasurements" :key="unitMeasurement.id">
              {{ unitMeasurement.name }}
            </option>
          </select>
        </div>

        <div class="field">
          <label for="reservation_type">Choose item category</label>
          <select
            class="ui fluid search dropdown"
            id="item-category-search"
            v-model="package.item_category_id"
            name="itemCategory"
          >
            <option value="">Choose item category</option>
            <option :value="itemCategory.id" v-for="itemCategory in itemCategories" :key="itemCategory.id">
              {{ itemCategory.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="fields">
        <div class="field" style="width: 50%">
          <label for="start_at">Start At</label>
          <div style="text-align: center" class="ui calendar" :id="'start-at'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'Start At'"
                     readonly=""
                     name="start_at">
            </div>
          </div>
        </div>

        <div class="field" style="width: 50%">
          <label for="finish_at">Finished At</label>
          <div style="text-align: center" class="ui calendar" :id="'finish-at'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'Finish At'"
                     readonly=""
                     name="finish_at">
            </div>
          </div>
        </div>
      </div>
      <div class="ui divider">  </div>

      <div class="ui blue right floated button"
           style="background-color: #092442"
           :class="{disabled: isNotValidForm}"
           @click="submit()">
        Submit
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    object: { type: Array, required: true },
    medicalMachines: { type: Array, required: true },
    items: { type: Array, required: true },
    package: { type: Object, required: true },
    forItemCategory: { type: Boolean, default: false},
    itemCategories: {type: Array, required: true},
    isNotValidForm: { type:Boolean, default: true }
  },
  watch: {
    package: {
      handler: function () {
        this.isNotValidForm = !$('#new-default-package-step').form('is valid')
      },
      deep: true
    }
  },
  computed: {
    medicalMachinesPackages () {
      return window._.flatten(window._.map(this.medicalMachines, medicalMachine => medicalMachine.packages))
    },
    itemsPackages () {
      return window._.flatten(window._.map(this.items, item => item.packages))
    }
  },
  methods: {
    hideModal () {
      $('#package').modal('hide')
    },
    submit () {
      this.$http.post('packages', {
        package: this.package,
        clinic_id: this.getFromLocalStorage('clinicId')
      }).then(response => {
        this.object.push(response.data)
        this.hideModal()
      })
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/clinics/clinic_components/packages/NewBigPackage.vue